import { CryptaInterestTypeWeb } from '../../typings/graphql-grid';
import { InterestsSetType } from '../../typings/interestsEditor';

export const OPEN_INTERESTS_TARGETING_EDITOR = 'OPEN_INTERESTS_TARGETING_EDITOR';
export type OPEN_INTERESTS_TARGETING_EDITOR = typeof OPEN_INTERESTS_TARGETING_EDITOR;

export interface OpenInterestsTargetingEditor {
    type: OPEN_INTERESTS_TARGETING_EDITOR;
    id: string;
    value: InterestsSetType[];
}

export function openInterestsTargetingEditor(id: string, value: InterestsSetType[]): OpenInterestsTargetingEditor {
    return {
        type: OPEN_INTERESTS_TARGETING_EDITOR,
        id,
        value
    };
}

export const CLOSE_INTERESTS_TARGETING_EDITOR = 'CLOSE_INTERESTS_TARGETING_EDITOR';
export type CLOSE_INTERESTS_TARGETING_EDITOR = typeof CLOSE_INTERESTS_TARGETING_EDITOR;

export interface CloseInterestsTargetingEditor {
    type: CLOSE_INTERESTS_TARGETING_EDITOR;
    id: string;
    value?: InterestsSetType[];
}

export const RESET_INTERESTS_TARGETING_EDITOR = 'RESET_INTERESTS_TARGETING_EDITOR';
export type RESET_INTERESTS_TARGETING_EDITOR = typeof RESET_INTERESTS_TARGETING_EDITOR;

export interface ResetInterestsTargetingEditor {
    type: RESET_INTERESTS_TARGETING_EDITOR;
    id: string;
}

export function resetInterestsTargetingEditor(id: string): ResetInterestsTargetingEditor {
    return {
        type: RESET_INTERESTS_TARGETING_EDITOR,
        id
    };
}

export function closeInterestsTargetingEditor(id: string, value?: InterestsSetType[]): CloseInterestsTargetingEditor {
    return {
        type: CLOSE_INTERESTS_TARGETING_EDITOR,
        id,
        value
    };
}

export const ADD_INTERESTS_TARGETING_SET = 'ADD_INTERESTS_TARGETING_SET';
export type ADD_INTERESTS_TARGETING_SET = typeof ADD_INTERESTS_TARGETING_SET;

export interface AddInterestsTargetingSet {
    type: ADD_INTERESTS_TARGETING_SET;
    id: string;
    isDisabledPeriod: boolean;
}

export function addInterestsTargetingSet(id: string, isDisabledPeriod: boolean): AddInterestsTargetingSet {
    return {
        type: ADD_INTERESTS_TARGETING_SET,
        id,
        isDisabledPeriod
    };
}

export const SELECT_ITEM_INTERESTS_EDITOR = 'SELECT_ITEM_INTERESTS_EDITOR';
export type SELECT_ITEM_INTERESTS_EDITOR = typeof SELECT_ITEM_INTERESTS_EDITOR;

export interface SelectItemInterestsEditor {
    type: SELECT_ITEM_INTERESTS_EDITOR;
    id: string;
    itemId: string;
    setIndex: number;
}

export function selectItemInterestsEditor(id: string, itemId: string, setIndex: number): SelectItemInterestsEditor {
    return {
        type: SELECT_ITEM_INTERESTS_EDITOR,
        id,
        itemId,
        setIndex
    };
}

export const INTERESTS_TARGETING_CHANGE_ITEM = 'INTERESTS_TARGETING_CHANGE_ITEM';
export type INTERESTS_TARGETING_CHANGE_ITEM = typeof INTERESTS_TARGETING_CHANGE_ITEM;

export interface InterestsTargetingChangeItem {
    type: INTERESTS_TARGETING_CHANGE_ITEM;
    id: string;
    itemId: string;
    setIndex: number;
}

export function interestsTargetingChangeItem(
    id: string,
    itemId: string,
    setIndex: number
): InterestsTargetingChangeItem {
    return {
        type: INTERESTS_TARGETING_CHANGE_ITEM,
        id,
        itemId,
        setIndex
    };
}

export const INTERESTS_TARGETING_CHANGE_SET_PERIOD = 'INTERESTS_TARGETING_CHANGE_SET_PERIOD';
export type INTERESTS_TARGETING_CHANGE_SET_PERIOD = typeof INTERESTS_TARGETING_CHANGE_SET_PERIOD;

export interface InterestsTargetingChangeSetPeriod {
    type: INTERESTS_TARGETING_CHANGE_SET_PERIOD;
    id: string;
    value: CryptaInterestTypeWeb;
    setIndex: number;
}

export function interestsTargetingChangeSetPeriod(
    id: string,
    value: CryptaInterestTypeWeb,
    setIndex: number
): InterestsTargetingChangeSetPeriod {
    return {
        type: INTERESTS_TARGETING_CHANGE_SET_PERIOD,
        id,
        value,
        setIndex
    };
}

export const REMOVE_INTERESTS_TARGETING_SET = 'REMOVE_INTERESTS_TARGETING_SET';
export type REMOVE_INTERESTS_TARGETING_SET = typeof REMOVE_INTERESTS_TARGETING_SET;

export interface RemoveInterestsTargetingSet {
    type: REMOVE_INTERESTS_TARGETING_SET;
    id: string;
    setIndex: number;
}

export function removeInterestsTargetingSet(id: string, setIndex: number): RemoveInterestsTargetingSet {
    return {
        type: REMOVE_INTERESTS_TARGETING_SET,
        id,
        setIndex
    };
}

export const SAVE_INTERESTS_TARGETING_SET = 'SAVE_INTERESTS_TARGETING_SET';
export type SAVE_INTERESTS_TARGETING_SET = typeof SAVE_INTERESTS_TARGETING_SET;

export interface SaveInterestsTargetingSet {
    type: SAVE_INTERESTS_TARGETING_SET;
    id: string;
}

export function saveInterestsTargetingSet(id: string): SaveInterestsTargetingSet {
    return {
        type: SAVE_INTERESTS_TARGETING_SET,
        id
    };
}

export type InterestsTargetingEditorAction =
    | CloseInterestsTargetingEditor
    | ResetInterestsTargetingEditor
    | OpenInterestsTargetingEditor
    | InterestsTargetingChangeItem
    | SelectItemInterestsEditor
    | AddInterestsTargetingSet
    | InterestsTargetingChangeSetPeriod
    | RemoveInterestsTargetingSet
    | SaveInterestsTargetingSet;
